import { type FC } from 'react'

import { ProductPicture } from '../../../product'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

const MAX_IMAGE_SIZE = 100

export const ProductSearchResultItemImage: FC = () => {
  const { algoliaRecord } = useProductSearchResultItemContext()

  const { image, productName } = algoliaRecord

  return (
    <ProductPicture
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className="size-[70px] tablet:size-[100px]"
      imageProps={{
        alt: productName,
        'data-analytics': 'item-image',
        height: MAX_IMAGE_SIZE,
        src: image,
        width: MAX_IMAGE_SIZE,
      }}
    />
  )
}
